import React from 'react'
import CustomLink from '@atoms/CustomLink/CustomLink'
import { useMultiSite } from 'msp-integrations'
import Image from '@atoms/Image/Image'

export const ImageComponent = (
  image: any,
  index: number,
  linkedImageStyle: string
) => (
  <div className='moodBoardImgWrapper'>
    <div
      className={`moodBoardImgRatio${index % 2 ? 'Vertical' : 'Horizontal'}`}
    >
      <Image
        src={image.url}
        alt={image.alt || `Fallback Alt - Please Replace`}
        className={`${!!image?.link ? linkedImageStyle : ''
          } absolute left-0 top-0 h-full w-full object-cover object-center`}
        ratio='1/4'
      />
    </div>
  </div>
)

export const ImageComponentContent = (
  image: any,
  index: number,
  linkedImageStyle: string
) => {
  if (!!image?.link) {
    const { buildUrl } = useMultiSite()
    let imageLink = image.link
    const isExternal = imageLink.indexOf('://') !== -1
    if (!isExternal && imageLink !== '/') {
      imageLink = buildUrl(imageLink)
    }
    return (
      <CustomLink
        href={imageLink}
        title={image.linkTitle}
        className='w-full'
        inline
      >
        {ImageComponent(image, index, linkedImageStyle)}
      </CustomLink>
    )
  } else if (image.hotSpotBubble) {
    return (
      <>
        {ImageComponent(image, index, linkedImageStyle)}
        {image.hotSpotBubble}
      </>
    )
  } else {
    return ImageComponent(image, index, linkedImageStyle)
  }
}
